import { browser } from '$app/environment';
import { activateDisplayLocale } from '$lib/i18n/activate-display-locale';
import { AppInitializationService } from '$lib/services/app-initialization';

export const prerender = true;
export const trailingSlash = 'always';

/**
 * Activates display locale and preloads shared chrome copy for every route.
 * @param {import('./$types').LayoutLoadEvent} event - SvelteKit layout load event.
 * @returns {Promise<object>} Empty layout data.
 */
export async function load(event) {
	if (browser) {
		event.depends('app:locale');
		await AppInitializationService.waitForInitialization();
		await activateDisplayLocale();
	}

	return {};
}
